var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('img',{attrs:{"src":require("../assets/img/home_icon.png"),"alt":""}}),_vm._v(" 首页 — "+_vm._s(_vm.breadcrumb)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }